/** Semantic keys for `HighlightIcon` — used in i18n JSON instead of emoji. */
export const HIGHLIGHT_ICON_IDS = [
  'archive',
  'bank',
  'book',
  'briefcase',
  'building',
  'calendar',
  'cart',
  'chart-bar',
  'chart-trend',
  'check',
  'clipboard',
  'cloud',
  'compass',
  'currency',
  'factory',
  'film',
  'flask',
  'folder',
  'globe',
  'government',
  'graduation',
  'handshake',
  'health',
  'key',
  'layers',
  'link',
  'lock',
  'pen',
  'phone',
  'plug',
  'puzzle',
  'refresh',
  'robot',
  'ruler',
  'settings',
  'shield',
  'signal',
  'sparkles',
  'target',
  'tools',
  'trophy',
  'user',
  'users',
  'video',
  'wrench',
  'zap',
] as const;

export type HighlightIconId = (typeof HIGHLIGHT_ICON_IDS)[number];

/** Legacy emoji → semantic id (for old copy until JSON is fully migrated). */
export const EMOJI_TO_HIGHLIGHT_ICON: Record<string, HighlightIconId> = {
  '🛡️': 'shield',
  '⚡': 'zap',
  '🌐': 'globe',
  '🌍': 'globe',
  '✨': 'sparkles',
  '☁️': 'cloud',
  '🤖': 'robot',
  '🔗': 'link',
  '🔒': 'lock',
  '👥': 'users',
  '🏦': 'bank',
  '🏥': 'health',
  '🛒': 'cart',
  '🏭': 'factory',
  '📡': 'signal',
  '🏛️': 'government',
  '🎬': 'film',
  '🧭': 'compass',
  '🛠️': 'tools',
  '📈': 'chart-trend',
  '📐': 'ruler',
  '🔧': 'wrench',
  '✅': 'check',
  '⚙️': 'settings',
  '🔄': 'refresh',
  '📚': 'book',
  '🧪': 'flask',
  '👤': 'user',
  '📊': 'chart-bar',
  '📅': 'calendar',
  '📁': 'folder',
  '🧩': 'puzzle',
  '🎯': 'target',
  '🤝': 'handshake',
  '💼': 'briefcase',
  '🏗️': 'building',
  '📞': 'phone',
  '🔐': 'key',
  '📋': 'clipboard',
  '🔌': 'plug',
  '📝': 'pen',
  '🗂️': 'archive',
  '💰': 'currency',
  '🎓': 'graduation',
  '📹': 'video',
  '🏆': 'trophy',
};

const ID_SET = new Set<string>(HIGHLIGHT_ICON_IDS);

export function resolveHighlightIconId(value?: string | null): HighlightIconId | null {
  if (!value?.trim()) return null;
  const trimmed = value.trim();
  if (ID_SET.has(trimmed)) return trimmed as HighlightIconId;
  return EMOJI_TO_HIGHLIGHT_ICON[trimmed] ?? null;
}
